import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomePage from '../home/index.jsx'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* Additional routes can be added here as pages are ready */}
      </Routes>
    </Router>
  )
}

export default App
